import { COLOURS } from '../styles';

export const FIRMWARE_VERSIONS = [
  { name: '1.15B14', colour: COLOURS.modelPooltek }, //grren
  // { name: "1.15B15", colour: COLOURS.heating },    //orange
  //{ name: "1.15B82", colour: COLOURS.warning },    //orange
  { name: '1.16B1', colour: COLOURS.good }, //grren
  //{ name: "1.15B83", colour: COLOURS.warning },    //orange
  // { name: "1.15B84", colour: COLOURS.warning },    //orange
  // { name: "1.15B85", colour: COLOURS.warning },    //orange
  { name: '1.16B2', colour: COLOURS.good }, //grren
  { name: 'Beta', colour: COLOURS.warning }, //orange

  // { name: "1.01B2", color: "orange" },
  // { name: "1.02B1", color: "amber" },
  // { name: "1.03B1", color: "green" }
];
